import { combineReducers } from 'redux';

import answerTime from './answerTime';
import auditInFilesSummary from './auditInFilesSummary';
import auditInFilesTable from './auditInFilesTable';
import brands from './brands';
import chat from './chat';
import customerOpinionStats from './customerOpinionStats';
import dealersStats from './dealersStats';
import dealersStatsTotal from './dealersStatsTotal';
import followUpStats from './followUpStats';
import interventionCount from './interventionCount';
import interventionRating from './interventionRating';
import interventionStats from './interventionStats';
import revenueByBrandStats from './revenueByBrandStats';
import revenueByPeriodStats from './revenueByPeriodStats';
import revenueStats from './revenueStats';
import selfServiceDashboard from './selfServiceDashboard';
import selfServiceDetails from './selfServiceDetails';
import selfServiceTopContributorsStats from './selfServiceTopContributors';
import timeLineStats from './timeLineStats';
import topContributorsStats from './topContributorsStats';

/**
 * @typedef {{
 *  chat: import('./chat').ChatStatisticsReducer,
 *  brands: import('./brands').StatisticsBrandsReducer,
 *  answerTime: import('./answerTime').StatisticsAnswerReducer,
 *  auditInFilesTable: ReturnType<typeof import('./auditInFilesTable').default>,
 *  auditInFilesSummary: ReturnType<typeof import('./auditInFilesSummary').default>,
 *  dealersStats: import('./dealersStats').StatisticsDealersReducer,
 *  revenueStats: import('./revenueStats').StatisticsRevenueReducer,
 *  timeLineStats: import('./timeLineStats').StatisticsTimelineReducer,
 *  followUpStats: import('./followUpStats').StatisticsFollowUpReducer,
 *  selfServiceDashboard: import('./selfServiceDashboard').StatisticsSelfServiceReducer,
 *  dealersStatsTotal: import('./dealersStatsTotal').StatisticsTotalReducer,
 *  interventionStats: import('./interventionStats').StatisticsInterventionReducer,
 *  interventionCount: import('./interventionCount').StatisticsInterventionCountReducer,
 *  interventionRating: import('./interventionRating').StatisticsInterventionRatingReducer,
 *  revenueByBrandStats: import('./revenueByBrandStats').StatisticsRevenueByBrandReducer,
 *  selfServiceDetails: import('./selfServiceDetails/status').StatisticsSelfServiceDetailsReducer,
 *  customerOpinionStats: import('./customerOpinionStats').StatisticsCustomerOptionReducer,
 *  revenueByPeriodStats: import('./revenueByPeriodStats').StatisticsRevenueByPeriodReducer,
 *  topContributorsStats: import('./topContributorsStats').StatisticsTopContributorReducer,
 *  selfServiceTopContributorsStats: import('./selfServiceTopContributors').StatisticsSelfServiceTopContributorReducer,
 * }} StatisticsDataReducer
 */

export default combineReducers({
  chat,
  brands,
  answerTime,
  auditInFilesTable,
  auditInFilesSummary,
  dealersStats,
  revenueStats,
  timeLineStats,
  dealersStatsTotal,
  interventionCount,
  interventionStats,
  interventionRating,
  followUpStats,
  selfServiceDetails,
  revenueByBrandStats,
  selfServiceDashboard,
  customerOpinionStats,
  revenueByPeriodStats,
  selfServiceTopContributorsStats,
  topContributorsStats
});
